export default __webpack_public_path__ + "web/src/assets/images/test_with_playground/appstore@2x.png?[fullhash]";